import { render, staticRenderFns } from "./auth-sso.vue?vue&type=template&id=5436807f&scoped=true"
import script from "./auth-sso.vue?vue&type=script&lang=js"
export * from "./auth-sso.vue?vue&type=script&lang=js"
import style0 from "./auth-sso.vue?vue&type=style&index=0&id=5436807f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5436807f",
  null
  
)

export default component.exports